/** ... */
const evaluationForm: DataGatherer.Form = {
  type: 'evaluation',
  id: 'a9a7db6f-8852-4f0d-b092-24c7b4089266',
  interpretAs: 'a9a7db6f-8852-4f0d-b092-24c7b4089266',
  sourceId: 'a9a7db6f-8852-4f0d-b092-24c7b4089266',
  name: 'LSI-R:SV',
  rules: [
    {
      type: 'Omit',
      amount: 1,
      omitValue: '-1',
      ruleText: 'You may omit a maximum of 1 items.',
    },
  ],
  fields: [
    {
      id: 'u5DJHdVD',
      referenceId: '',
      label: 'General Notes for Evaluation',
      sequenceNumber: 13,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: '4gpmwFox',
      referenceId: '',
      label: 'Additional Comments',
      sequenceNumber: 15,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'IZOocHGW',
      referenceId: '1',
      label: 'Two or more prior adult convictions?',
      sequenceNumber: 1,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'MWQ6AG9N',
      referenceId: '',
      label: 'Question 1 Comment',
      sequenceNumber: 16,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'WgGqE2h1',
      referenceId: '2',
      label: 'Arrested under age 16?',
      sequenceNumber: 2,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'AIKJiKD0',
      referenceId: '',
      label: 'Question 2 Comment',
      sequenceNumber: 17,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: '0pCyJDch',
      referenceId: '3',
      label: 'Currently unemployed?',
      sequenceNumber: 3,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'le4sWNUB',
      referenceId: '',
      label: 'Question 3 Comment',
      sequenceNumber: 18,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'enuKXxA0',
      referenceId: '4',
      label: 'Some criminal friends',
      sequenceNumber: 4,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'vyqKC50k',
      referenceId: '',
      label: 'Question 4 Comment',
      sequenceNumber: 19,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: '7ZKk9atS',
      referenceId: '5',
      label: 'Alcohol/drug problem: School/work',
      sequenceNumber: 5,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'd2yihz7i',
      referenceId: '',
      label: 'Question 5 Comment',
      sequenceNumber: 20,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'VvSd0gZy',
      referenceId: '6',
      label: 'Psychological assessment indicated',
      sequenceNumber: 6,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: '3JuHKcPT',
      referenceId: '',
      label: 'Question 6 Comment',
      sequenceNumber: 21,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'cnGo9oEi',
      referenceId: '7',
      label: 'Non-rewarding, parental',
      sequenceNumber: 7,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Satisfactory', value: '3' },
        { label: 'Relatively Satisfactory', value: '2' },
        { label: 'Relatively Unsatisfactory', value: '1' },
        { label: 'Very Unsatisfactory', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'runMmcEe',
      referenceId: '',
      label: 'Question 7 Comment',
      sequenceNumber: 22,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'ZAF6GDeC',
      referenceId: '8',
      label: 'Attitudes/orientation: Supportive of crime',
      sequenceNumber: 8,
      required: true,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'evaluate',
      answers: [
        { label: 'Satisfactory', value: '3' },
        { label: 'Relatively Satisfactory', value: '2' },
        { label: 'Relatively Unsatisfactory', value: '1' },
        { label: 'Very Unsatisfactory', value: '0' },
        { label: 'Omit', value: '-1' },
      ],
    },
    {
      id: 'plATr7H9',
      referenceId: '',
      label: 'Question 8 Comment',
      sequenceNumber: 23,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
  ],
};

/** ... */
const generalInformationForm: DataGatherer.Form = {
  id: 'a0d85abd-d338-4875-b97a-43aa1213ddae',
  interpretAs: 'a0d85abd-d338-4875-b97a-43aa1213ddae',
  sourceId: 'a0d85abd-d338-4875-b97a-43aa1213ddae',
  name: 'General Information',
  type: 'unknown',
  fields: [
    {
      id: 'UHucvRjw',
      referenceId: '',
      label: 'Name of Assessed',
      sequenceNumber: 1,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'jYqir8xf',
      referenceId: '',
      label: "Interviewer's Name",
      sequenceNumber: 2,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'CpXmx3HE',
      referenceId: '',
      label: 'Date of Birth',
      sequenceNumber: 3,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'date',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'Bo8CB6V4',
      referenceId: '',
      label: 'Gender',
      sequenceNumber: 4,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'unscoredObservations',
      answers: [
        { label: 'Male', value: 0 },
        { label: 'Female', value: 1 },
      ],
      hideSequenceNumber: true,
    },
    {
      id: 'Zpoqbp4E',
      referenceId: '',
      label: 'Date of Test Administration',
      sequenceNumber: 5,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'date',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'ms9Qx7Eq',
      referenceId: '',
      label: 'Identifying Source',
      sequenceNumber: 6,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'vwvkLClg',
      referenceId: '',
      label: 'Referral Source',
      sequenceNumber: 7,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'fZ1NXbJc',
      referenceId: '',
      label: 'Reason for Referral',
      sequenceNumber: 8,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'W72g7cr1',
      referenceId: '',
      label: 'Disposition',
      sequenceNumber: 9,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'luWr33V3',
      referenceId: '',
      label: 'Present Offences',
      sequenceNumber: 10,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'SKCMvE8m',
      referenceId: '',
      label: 'Race/Ethnicity',
      sequenceNumber: 11,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
    {
      id: 'NesNC1Gv',
      referenceId: '',
      label: 'Current Location',
      sequenceNumber: 12,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredObservations',
      hideSequenceNumber: true,
    },
  ],
};

/** ... */
const references: DataGatherer.Tool.Reference[] = [
  {
    id: '1',
    title: 'Reference Text',
    content:
      'One conviction equals any Number of offenses dealt with at the same time or by one sentence.',
  },
  {
    id: '2',
    title: 'Reference Text',
    content:
      'This item is not intended for offenders who simply have a record of juvenile delinquency. The definition of a juvenile delinquent or young offender varies from jurisdiction to jurisdiction and someone who is considered a young offender in one location may be treated as an adult offender in another setting. However, the onset of antisocial behavior is a relatively good predictor of recidivism and the earlier an individual begins to commit criminal acts the more likely it is that he or she will continue.',
  },
  {
    id: '3',
    title: 'Reference Text',
    content:
      "Some care must be taken in scoring this item when the offender is an inmate. Strictly speaking, all inmates are unemployed. However, when the inmate is serving a relatively short sentence it may be helpful to view his or her incarceration as a type of “leave without pay.” Consider whether the inmate was working prior to incarceration and if so, will the inmate be able to return to the same job? If the answer is no, then the offender is assessed as unemployed. This item applies to offenders who are in the labor market (i.e., able and willing to work). If the offender is in school on a full-time basis, a homemaker by choice, or on a pension, then do not score the offender as unemployed. Select the response of 'No' for this item.",
  },
  {
    id: '4',
    title: 'Reference Text',
    content:
      'Answer “Yes” if the offender has friends (or had friends prior to incarceration) who have criminal records or are involved in criminal activity. Friends are considered to be associates with whom one spends leisure time, whose opinions are valued, who provide help when in difficulty, etc.',
  },
  {
    id: '5',
    title: 'Reference Text',
    content:
      'Scoring this items requires two steps. First, the case administrator must establish whether or not the offender has a current alcohol or drug problem. If the case administrator is satisfied that a substance abuse problem exists, then the case administrator goes to the second step and ascertains whether the offender’s substance abuse interferes with academic achievement and/or work performance. A current substance-abuse problem refers to one that occurred during the past year. Those who have abstained from alcohol and drugs for more than one year, and for whom this information can be verified, would not receive a score. If the offender says that substance abuse is a problem for him or her, then this admission should be accepted as a truthful one. However, do not accept unquestionably an offender’s denial of a problem. Always look for concrete evidence. For example, it is not unusual for some offenders to say that they do not have a drinking problem or that drugs do not interfere with life when actually the offender drinks enormous quantities of alcohol, or the offender’s partner left because the offender has a substance-abuse problem. When assessing an incarcerated offender, consider his or her alcohol and drug consumption (drinking and drug-taking) behavior during the year prior to incarceration. Consider also any use of substances while incarcerated. For offenders convicted of trafficking in drugs, do not assume that they have a drug problem. Some drug traffickers engage in this behavior as part of their “business” and may not use the drug. The offender must be a regular alcohol or drug abuser to be scored as having a substance-abuse problem. When the answer is “Yes” to the abuse of alcohol or drugs, the case administrator should then focus upon problems specifically in the areas of school or employment. Examples of problems in this domain include the following: a hangover prevented the offender from going to school or work; the offender was asked to leave school because of drug use; or the offender lost employment because he or she was intoxicated on the job.',
  },
  {
    id: '6',
    title: 'Reference Text',
    content:
      'If the offender has been assessed within the past year and the case administrator has knowledge of the problems that the assessment indicated were present, answer “Yes” for this item and note what that assessment indicated. If the offender has never been assessed, or if it is unknown whether the offender has ever been assessed, but there are indicators of problems with the following, answer “Yes” to this item. Note in the space provided the problems identified; for example, the offender\n- has problematic intellectual functioning \n\n- has little or no academic/vocational potential and/or interests \n\n- exhibits excessive fears and/or negative attitudes towards self; suffers from depression; feels tension \n\n- displays hostility, anger, a potential for assaultive behavior, and/or aggression \n\n- has poor impulse control and/or self-management skills  \n\n- has poor interpersonal skills; is underassertive \n\n- cannot discern reality; exhibits severe withdrawal; displays over-activity; possibly experiences delusions/ hallucinations \n\n- disregards the feelings of others; possesses a reduced ability or inability to experience guilt/shame; may be superficially “charming” but repeatedly disregards rules and feelings of others \n\n- commits criminal acts that do not make sense; appears irrational \n\n- other (specify)',
  },
  {
    id: '7',
    title: 'Reference Text',
    content:
      'A “parent” does not necessarily have to be a biological parent. Any figure that has played a parenting role (e.g., adoptive parent or a grandparent who raised the offender from an early age) can be considered when rating this item. Note that this item is rated according to the following guidelines: \n\nHighest Level (3) \nAt this level, the offender sees or writes his or her parents often and overt expressions of affection are evident (e.g., hugs or kisses when greeting them). The relationship is liking/ loving, open, and warm. The offender talks about important matters with his or her parents and cares about what they think, expect, and feel. “3” indicates a highly rewarding, satisfying relationship. \n\nLowest Level (0) \nAt this level, the offender argues with his or her parents when they are together and rarely sees or writes them. The relationship ranges from dislike to hatred, and the offender does not care what his or her parents think, feel, or expect. \n\n“0” indicates a punishing, unpleasant, uncaring, hostile, indifferent relationship; OR that both parents are deceased; OR that one parent is deceased or absent from home and there is a negative relationship with the parent being seen most often.\n\n3. A satisfactory situation with no need for improvement\n2. A relatively satisfactory situation with some room for improvement evident\n1. A relatively unsatisfactory situation with a need for improvement\n0. A very unsatisfactory situation with a very clear and strong need for improvement',
  },
  {
    id: '8',
    title: 'Reference Text',
    content:
      'This item is concerned with what and how a person thinks about him- or herself, others, and the world. Are his or her attitudes, values, beliefs, and thinking procriminal and antisocial or anticriminal and prosocial? Note that this item also requires a numeric rating: \n\nHighest Level (3) \nAt this level, the offender places emphasis on the negative consequences of law violation for the offender, the victim and the community. He or she accepts responsibility for his or her own actions and the consequences of those actions. The offender rejects or at least places more realistic limits on rationalizations or justifications for law violations. He or she identifies with the victim of the crime and expresses the risk involved in associating with other criminals or accepting their values. \n\nLowest Level (0) \nAt this level, the offender places an emphasis on the usefulness of criminal activity. His or her motives are more readily served by crime than by non-crime. The offender expresses acceptance of the common rationalizations or justifications for law violations (e.g., “it wasn’t my fault,” “no one was hurt,” and/or “the victim had it coming to him”). He or she denies or minimizes responsibility for his or her actions and their consequences. The offender expresses outright rejection of, or fails to empathize or be sensitive to, the feelings, wishes, and expectations of others, including the victims of criminal behavior. He or she accepts other criminals and their values and activities, and expresses hostility toward the criminal justice system.\n\n3. A satisfactory situation with no need for improvement\n2. A relatively satisfactory situation with some room for improvement evident\n1. A relatively unsatisfactory situation with a need for improvement\n0. A very unsatisfactory situation with a very clear and strong need for improvement',
  },
];

/** ... */
export const data: DataGatherer.Tool = {
  id: 'LSI-R:SV',
  measureId: 'c8733e99-2501-4052-b4da-b77756d59248',
  evaluatorId: '8ac62a62-9aed-40a7-983a-a14fb57e725f',
  version: '0.0.1',
  name: 'LSI-R:SV',
  references,
  forms: [generalInformationForm, evaluationForm],
};
